import React, { Component } from "react";
import { RECIPE_COLOURS } from "./DoserRecipePane";
import TimeDurSelect from "./TimeDurSelect";

const TEXT = "#2c3e50";
const BORDER = "#c5ced8";
const NONE_COLOUR = "#9aa5b1";

const rowStyle = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: 10,
  fontFamily: "system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  width: "100%",
  boxSizing: "border-box",
};

const idxBadgeStyle = {
  width: 28,
  height: 28,
  borderRadius: "50%",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  fontSize: 13,
  fontWeight: 700,
  flexShrink: 0,
  fontVariantNumeric: "tabular-nums",
};

const controlStyle = {
  height: 36,
  padding: "0 10px",
  borderRadius: 8,
  border: `1px solid ${BORDER}`,
  boxSizing: "border-box",
  fontSize: 14,
  fontFamily: "inherit",
  color: TEXT,
  background: "#fff",
};

const selectStyle = {
  ...controlStyle,
  minWidth: 140,
  maxWidth: 220,
  flex: "1 1 140px",
  cursor: "pointer",
};

const timeWrapStyle = {
  width: 130,
  flex: "0 0 auto",
};

const notesStyle = {
  ...controlStyle,
  flex: "1 1 160px",
  minWidth: 140,
  maxWidth: 280,
};

const deleteBtnStyle = {
  width: 36,
  height: 36,
  borderRadius: 8,
  border: `1px solid ${BORDER}`,
  background: "#fff",
  color: "#c62828",
  fontSize: 18,
  fontWeight: 700,
  lineHeight: 1,
  cursor: "pointer",
  flexShrink: 0,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  fontFamily: "inherit",
};

export default class ScheduleItem extends Component {
  emit(payload) {
    const { onChange, idx } = this.props;
    if (typeof onChange === "function") {
      onChange({ ...payload, index: idx });
    }
  }

  resolveColour() {
    const { color, recipeId, recipes, idx } = this.props;
    if (color) return color;
    if (!recipeId || recipeId === "none") return NONE_COLOUR;
    const list = recipes || [];
    const found = list.find((r) => r.recipeId === recipeId);
    if (found && found.color) return found.color;
    const i = Math.max(0, (Number(idx) || 1) - 1);
    return RECIPE_COLOURS[i % RECIPE_COLOURS.length];
  }

  render() {
    const {
      idx,
      recipeId,
      recipes,
      dayMins,
      notes,
      err,
    } = this.props;
    const sorted = [...(recipes || [])]
      .filter((r) => r && r.recipeId && r.recipeId !== "none")
      .sort((a, b) => String(a.name || "").localeCompare(String(b.name || "")));
    const colour = this.resolveColour();

    return (
      <div
        style={{
          ...rowStyle,
          background: err ? "#FFEEEE" : "transparent",
          borderRadius: 8,
          padding: err ? "4px 0" : 0,
        }}
      >
        <div
          style={{ ...idxBadgeStyle, background: colour }}
          aria-label={`Schedule row ${idx}`}
        >
          {idx}
        </div>

        <select
          style={selectStyle}
          value={recipeId || "none"}
          onChange={(e) => this.emit({ type: "recipe", value: e.target.value })}
          aria-label={`Recipe for row ${idx}`}
        >
          <option value="none">Select a Recipe</option>
          {sorted.map((r) => (
            <option key={r.recipeId} value={r.recipeId}>
              {r.name}
            </option>
          ))}
        </select>

        <TimeDurSelect
          mode="time"
          style={timeWrapStyle}
          value={dayMins || 0}
          onChange={(mins) => this.emit({ type: "time", value: mins })}
        />

        <input
          type="text"
          style={notesStyle}
          value={notes == null ? "" : notes}
          placeholder=""
          onChange={(e) => this.emit({ type: "notes", value: e.target.value })}
          aria-label={`Notes for row ${idx}`}
        />

        <button
          type="button"
          style={deleteBtnStyle}
          title="Delete row"
          aria-label={`Delete schedule row ${idx}`}
          onClick={() => this.emit({ type: "delete" })}
        >
          ×
        </button>
      </div>
    );
  }
}
